export const FETCH_LATEST_DATA_REQUEST =
  "API/ENTITIES/DESIGN_DATA/FETCH_LATEST_REQUEST";
export const FETCH_LATEST_DATA_REQUEST_SUCCESS =
  "API/ENTITIES/DESIGN_DATA/FETCH_LATEST_REQUEST_SUCCESS";
export const FETCH_LATEST_DATA_REQUEST_FAILURE =
  "API/ENTITIES/DESIGN_DATA/FETCH_LATEST_REQUEST_FAILURE";

export const CLEAR_ALL_DESIGN_DATA = "API/ENTITIES/DESIGN_DATA/CLEAR_ALL_DATA";
